exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".force-fullscreen{z-index:10001!important}.force-fullscreen+.md-overlay{z-index:10000!important}", ""]);

// exports
